import { siteName } from "src/config/termConfig";
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Card, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "src/styles/survey-login/index.scss";

interface LoginFormValues {
  username: string;
  password: string;
}

const SurveyLoginPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Agar allaqachon login qilgan bo'lsa, docs sahifasiga yo'naltirish
  useEffect(() => {
    const isAuthenticated = localStorage.getItem("surveyAuth");
    if (isAuthenticated) {
      navigate("/survey-docs");
    }
  }, [navigate]);

  // Statik login va parol
  const STATIC_CREDENTIALS = {
    username: "admin",
    password: "survey2024",
  };

  const onFinish = (values: LoginFormValues) => {
    setLoading(true);

    // Statik login va parolni tekshirish
    setTimeout(() => {
      if (
        values.username === STATIC_CREDENTIALS.username &&
        values.password === STATIC_CREDENTIALS.password
      ) {
        // Login holatini localStorage ga saqlash
        localStorage.setItem("surveyAuth", "true");
        message.success("Muvaffaqiyatli kirdingiz!");
        navigate("/survey-docs");
      } else {
        message.error("Login yoki parol noto'g'ri!");
      }
      setLoading(false);
    }, 1000);
  };

  return (
    <div className="survey-login">
      <div className="survey-login__container">
        <Card className="survey-login__card">
          <div className="survey-login__header">
            <h1 className="survey-login__title">
              Ichki audit faoliyatiga oid so'rovnoma
            </h1>
            <p className="survey-login__subtitle">{siteName} tizimiga kirish</p>
          </div>

          <Form
            name="survey-login"
            className="survey-login__form"
            onFinish={onFinish}
            layout="vertical"
            size="large"
          >
            <Form.Item
              name="username"
              label="Foydalanuvchi nomi"
              rules={[
                {
                  required: true,
                  message: "Foydalanuvchi nomini kiriting!",
                },
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Foydalanuvchi nomi"
                autoComplete="username"
              />
            </Form.Item>

            <Form.Item
              name="password"
              label="Parol"
              rules={[
                {
                  required: true,
                  message: "Parolni kiriting!",
                },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Parol"
                autoComplete="current-password"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="survey-login__submit"
                loading={loading}
                block
              >
                Kirish
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default SurveyLoginPage;
